"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUtcFormat = exports.formatDate = exports.TIME_REGEX = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
require("dayjs/locale/ko");
var _1 = require(".");
dayjs_1.default.locale('ko');
exports.TIME_REGEX = /([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g;
var formatDate = function (date, format) {
    return (0, _1.parsePlaceholderWhenInvalidDate)((0, dayjs_1.default)(date).format(format));
};
exports.formatDate = formatDate;
var toUtcFormat = function (date) {
    return (0, dayjs_1.default)(date).utc(true).format().replace('Z', '');
};
exports.toUtcFormat = toUtcFormat;
